import { Fragment } from "react";

import SettingsEvent from "../components/Settings/SettingsEvent";

const SettingsEventPage = () => {
  return (
    <Fragment>
      <h1>Prodotti</h1>
      <SettingsEvent />
    </Fragment>
  );
};

export default SettingsEventPage;
